export default function ShareArrow({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.3125 16.026L21 10.013L12.3125 4V7.33958C7.52232 8.43939 4 12.1361 4 16.527C4 18.1438 4.47754 19.6665 5.32008 21C5.93361 17.4692 8.62492 14.5083 12.3125 13.0299V16.026Z"
        fill="currentColor"
      />
    </svg>
  )
}
